import categoryStore from "./categoryStore";
import stencilStore from "./stencilStore";
import eventStore from "./eventStore";
import stencilWeekStore from "./stencilWeekStore";

// Call to clear all stores upon logout
export const resetAllStores = () => {
    categoryStore.getState().reset();
    stencilStore.getState().reset();
    eventStore.getState().reset();
    stencilWeekStore.getState().reset();
}

// Call to clear stencil weeks store on end/cancel event
export const resetStencilWeekStore = () => {
    stencilWeekStore.getState().reset();
}